import { render, staticRenderFns } from "./EditLeaderDialog.vue?vue&type=template&id=65c75bc4&scoped=true&"
import script from "./EditLeaderDialog.vue?vue&type=script&lang=ts&"
export * from "./EditLeaderDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c75bc4",
  null
  
)

export default component.exports